// src/ownerSecret.js

const PREFIX = "ownerSecret:";

/**
 * Returns the stored owner secret for a tail number, or null if none exists.
 */
export function getOwnerSecret(tail) {
  if (!tail) return null;
  return localStorage.getItem(PREFIX + tail.toUpperCase());
}

/**
 * Stores an owner secret for a tail number (e.g. after creating a new
 * aircraft, the server returns one — save it with this).
 */
export function setOwnerSecret(tail, secret) {
  if (!tail || !secret) return;
  localStorage.setItem(PREFIX + tail.toUpperCase(), secret);
}

/**
 * Returns the stored secret for a tail, or generates + stores a new
 * random one if none exists yet. Use this before editing/deleting
 * data on an aircraft that might be a legacy record with no secret
 * claimed yet — sending this value claims it on the first request.
 */
export function getOrCreateOwnerSecret(tail) {
  const existing = getOwnerSecret(tail);
  if (existing) return existing;

  const fresh = crypto.randomUUID().replace(/-/g, "");
  setOwnerSecret(tail, fresh);
  return fresh;
}

/**
 * Convenience: the header object to spread into a fetch() call's headers.
 */
export function ownerSecretHeader(tail) {
  const adminSecret = getAdminSecret();

  if (adminSecret) {
    return {
      "X-Admin-Secret": adminSecret
    };
  }

  const ownerSecret = getOrCreateOwnerSecret(tail);

  return {
    "X-Owner-Secret": ownerSecret
  };
}

/**
 * admin key
 */

const ADMIN_SECRET_KEY = "adminSecret";

export function getAdminSecret() {
  return sessionStorage.getItem(ADMIN_SECRET_KEY);
}

export function setAdminSecret(secret) {
  if (!secret) return;
  sessionStorage.setItem(ADMIN_SECRET_KEY, secret);
}

export function clearAdminSecret() {
  sessionStorage.removeItem(ADMIN_SECRET_KEY);
}